import { render, staticRenderFns } from "./OrdersInboundTableContent.vue?vue&type=template&id=5d8ba0f0&scoped=true"
import script from "./OrdersInboundTableContent.vue?vue&type=script&lang=js"
export * from "./OrdersInboundTableContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8ba0f0",
  null
  
)

export default component.exports